import React from 'react';
import { Globe } from 'lucide-react';
import './CountryFlag.css';

const COUNTRY_NAMES = {
  US: 'United States',
  DO: 'Dominican Republic',
  TN: 'Tunisia',
  CO: 'Colombia',
  VE: 'Venezuela',
  AR: 'Argentina',
  PT: 'Portugal',
  BR: 'Brazil',
};

const VALID_CODES = new Set(Object.keys(COUNTRY_NAMES));

function CountryFlag({ code, size = 'small', className = '' }) {
  if (!code || !VALID_CODES.has(code)) {
    const iconSize = size === 'large' ? 20 : size === 'medium' ? 16 : 12;
    return (
      <span className={`country-flag country-flag--${size} country-flag--fallback ${className}`.trim()}>
        <Globe size={iconSize} strokeWidth={2} />
      </span>
    );
  }

  const countryName = COUNTRY_NAMES[code];

  return (
    <img
      src={`/flags/${code}.svg`}
      alt={`${countryName} flag`}
      className={`country-flag country-flag--${size} ${className}`.trim()}
      loading="lazy"
      draggable={false}
    />
  );
}

export default CountryFlag;
